export const initialState = {
  product: null,
  provider: null,
  activity: null,
};
